export enum TipoRecaptcha {
  Google = 'google',
  Cloudflare = 'cloudflare',
  Desabilitado = 'desabilitado',
  Nenhum = 'nenhum'
}
